import { render, staticRenderFns } from "./FilterCustomer.vue?vue&type=template&id=0d80cafd&scoped=true"
import script from "./FilterCustomer.vue?vue&type=script&lang=js"
export * from "./FilterCustomer.vue?vue&type=script&lang=js"
import style0 from "./FilterCustomer.vue?vue&type=style&index=0&id=0d80cafd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d80cafd",
  null
  
)

export default component.exports